import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runWeaverTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    return runIndependentProductionTick(
        settlement,
        'weaver',
        settlement.jobs.weavers,
        settlement.production.weaver.progress,
        config.production.weaver.ticksPerBatch,
    );
}
